export default "__VITE_ASSET__c4mKbrZT__"